module.exports = __webpack_public_path__ + "static/quini6-f628d78ddc87a0f1fbbbc4a819606689.svg";